import { render, staticRenderFns } from "./StudyCourse.vue?vue&type=template&id=0246b500&scoped=true&"
import script from "./StudyCourse.vue?vue&type=script&lang=js&"
export * from "./StudyCourse.vue?vue&type=script&lang=js&"
import style0 from "./StudyCourse.vue?vue&type=style&index=0&id=0246b500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0246b500",
  null
  
)

export default component.exports